<template>

<v-container class="fill-height black" fluid  >

    <div class="h5p-content" style="width: 99%; box-sizing: content-box;" :data-content-id="h5pdiv" :id="h5pdiv"></div>


<v-row class="black">
  <v-col cols="12" sm="6">
<v-list dense>
      <v-subheader>XAPI Tracker: {{trackerSession}} <v-btn @click="resetSession()"  x-small>RESET</v-btn>
        <v-progress-circular
      v-if="resetting"
      indeterminate
      color="primary"
    ></v-progress-circular> </v-subheader>
      <v-list-item-group v-model="xapi" color="primary">
        <v-list-item
          v-for="(item, i) in xapi"
          :key="i"
        >

          <v-list-item-icon>
            <v-icon >{{item.icon}}</v-icon>
          </v-list-item-icon>

          <v-list-item-content @click.stop="showXapi(item.statement)">
            <v-list-item-title v-text="item.verb"></v-list-item-title>


             <v-list-item-subtitle>
            {{item.actor}} {{item.verb}} {{item.title}} @ {{item.timestamp}}
          </v-list-item-subtitle>

           <v-list-item-subtitle v-if="item.hasscore">

                SCORE: {{item.score}}

           </v-list-item-subtitle>

          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

  </v-col>


  <v-col cols="12" sm="6">
       <v-toolbar dense><v-toolbar-title>Completion Tracker</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-checkbox
        v-model="completed"
        label="Activity Completed?"
        ></v-checkbox>


       </v-toolbar>
       <v-card>
{{this.completionType}}<br>
{{this.completionDesc}}
</v-card>
   </v-col>

</v-row>


 <v-dialog
      v-model="dialog"
      max-width="1000"
    >

   <v-container>
                          <v-card flat >
                            <pre><code>
  {{JSON.stringify(this.showXapidata, undefined, 10)}}
</code>
</pre>
</v-card></v-container>
</v-dialog>

</v-container>






</template>

<script>




import ShuttleMixins from '@/mixins/ShuttleMixins.js';
  export default {
    name: 'ShuttlePreview',
    mixins:[ShuttleMixins],
    props: {
      source: String,
    },
    data: () => ({

      dynamicH5p:{},
      xapi:[],
      showXapidata:{},
      dialog:false,
      completed:false,
      h5pdiv:'',
      trackerSession:'',

      completionType:'',
      completionDesc:'',
      resetting:false

    }),
    created () {



    },





    mounted () {

        this.loadPreview();




    },

    methods:{



        async loadPreview(){

         // //console.log('loadprevew');
         // //console.log(this.$store.state.currentShuttle.completion.id);

      var tempobj = this.$store.state.transcriptEdit;
      tempobj.transcript_segment_end = 0;
      tempobj.listenmode = 'preview';
      this.$store.commit('transcriptEdit', tempobj);



      this.h5pdiv = this.$route.params.id;
       this.setCurrentShuttle(this.$route.params.id);
        this.$store.commit('drawerState', false);




        ////console.log(this.$store.state.currentShuttle.completion)


        if(this.$store.state.currentShuttle.completion){

            switch(this.$store.state.currentShuttle.completion.id){

              case 'shuttle.video.quiz':

                  this.completionType = 'Quiz';


                  switch(this.$store.state.currentShuttle.completion.quiz_option){

                      case 'all_completed':
                          this.completionDesc = 'All Quizzes Must Be Completed (Even if Failed)'
                      break;


                      case 'all_passed':
                          this.completionDesc = 'All Quizzes Must Pass'
                      break;

                      case 'aggregate':
                          this.completionDesc = 'Aggregate Score of all Quizzes: ' + this.$store.state.currentShuttle.completion.quiz_score;
                      break;

                  }

                break;
                  case 'shuttle.video.end':

                      this.completionType = 'Strict';
                      this.completionDesc = 'Learner must watch entire video.'

                  break;


                  case 'shuttle.video.immediate':

                      this.completionType = 'Immediate';
                      this.completionDesc = 'As soon as this interactive experience is launched, it will be marked as completed..'

                  break;


                  case 'shuttle.video.watched':

                      this.completionType = 'Amount Watched: ' + this.fmtMSS(this.$store.state.currentShuttle.completion.seconds);
                      this.completionDesc = 'A user must watch a certain number of seconds in the the video. user can still skip around the video (unless prevented), but only unique video segment views will be counted. (i.e. a user cannot watch the same few seconds of video over and over again and have it count towards the total seconds needed to complete.)'

                  break;




            }
        }


        this.trackerSession = 'preview_' + this.$store.state['auth'].event_id + '_' + this.$store.state.currentShuttle.id;


        this.dynamicH5p = await this.generateDynamicH5p(true);

       var  shuttleInitObj = {
            studio:true,
            target: this.h5pdiv,
            shuttleId: this.h5pdiv,
            customerId: this.$store.state['auth'].sub,
            userDataUrl: this.$store.state.uri.api_base_uri + "track/user-data/" + this.trackerSession + '?data_type=:dataType&subContentId=:subContentId',
            xapiUrl: this.$store.state.uri.api_base_uri + "track/xapi/" + this.trackerSession,
            finishUrl: this.$store.state.uri.api_base_uri + "track/finish/" + this.trackerSession+ "?data_type=:dataType&subContentId=:subContentId",
            user:{
                externalId:this.$store.state['auth'].sub,
                firstName:this.$store.state['auth'].username,
                lastName:'',
                email: this.$store.state['auth'].email

            },
            xAPIDispatch:this.trackXAPI,
            content:this.dynamicH5p,
            mode:'Edit'

        }


       // //console.log(shuttleInitObj)



          this.$nextTick(function () {
              //console.log(document.getElementById(this.h5pdiv));




              shuttleInit(shuttleInitObj);




          });


        },

        async resetSession(){

            this.resetting = true;

            //console.log('reset session')

          let postshuttle = {};
          postshuttle.table = "shuttle_bookmarks"
          postshuttle.session = this.trackerSession;

          let path = 'track/user-data/'+this.trackerSession+'/reset';
          let shuttleresponse = await this.getData(path, 'post', postshuttle);


          postshuttle.table = "shuttle_quiz_results";
          postshuttle.session = this.trackerSession;

          shuttleresponse = await this.getData(path, 'post', postshuttle);


          this.xapi = [];
          location.reload();





        },

        trackXAPI(event){





              var verb = event.data.statement.verb.display['en-US']
              if (verb == 'cmi.interaction'){ verb = 'interacted'}


              var icon = ''
              switch(verb){

                  case 'played':
                    icon = 'mdi-motion-play'
                  break;

                  case 'paused':
                    icon = 'mdi-motion-pause'
                  break;


                  case 'launched':
                    icon = 'mdi-rocket-launch'
                  break;

                  case 'initialized':
                    icon = 'mdi-motion'
                  break;
                  case 'interacted':
                    icon = 'mdi-gesture-tap-hold'
                  break;

                  case 'answered':
                    icon = 'mdi-pencil-circle'
                  break;

                  case 'skipped':
                    icon = 'mdi-skip-next'
                  break;

                  case 'attempted':
                    icon = 'mdi-head-dots-horizontal'
                  break;

                  case 'scored':
                    icon = 'mdi-scoreboard'
                  break;

                  case 'passed':
                    icon = 'mdi-progress-check'
                  break;

                  case 'failed':
                    icon = 'mdi-progress-close'
                  break;
                  case 'completed':
                    icon = 'mdi-check-decagram'
                  break;


                  case 'video-completed':

                    icon = 'mdi-video-check'
                  break;


              }



              var xapidisplay = {
                  verb:verb,
                  statement:event.data.statement,
                  icon:icon

              }


              xapidisplay.title = '';
              if(event.data.statement.object.definition.name['en-US']){
                  xapidisplay.title = event.data.statement.object.definition.name['en-US'];

              }
              xapidisplay.actor = '';
              if(event.data.statement.actor){
                  xapidisplay.actor = event.data.statement.actor.name;

              }
              xapidisplay.timestamp = '';
              if(event.data.statement.object.definition.extensions['http://myshuttle.io/x-api/local-timestamp']){

                    xapidisplay.timestamp  =  event.data.statement.object.definition.extensions['http://myshuttle.io/x-api/local-timestamp']
              }


              xapidisplay.hasscore = false;
              xapidisplay.score ='';
              xapidisplay.passed = false;

              if(event.data.statement.result){
                  if(event.data.statement.result.score){

                      xapidisplay.hasscore = true;
                      xapidisplay.score = Math.round(event.data.statement.result.score.scaled * 100, 2);
                      xapidisplay.passed = event.data.statement.result.success;
                  }

              }




              this.xapi.push(xapidisplay)

              if(event.data.statement.verb.id == 'http://adlnet.gov/expapi/verbs/completed' || event.data.statement.verb.id == 'http://w3id.org/xapi/video/verbs/completed-already' || event.data.statement.verb.id == 'https://adlnet.gov/expapi/verbs/completed' || event.data.statement.verb.id == 'https://w3id.org/xapi/video/verbs/completed-already'){

                this.completed = true;
              }



        },

        showXapi(statement){

            this.showXapidata =statement;
            this.dialog = true;

        },



     async setCurrentShuttle(shuttleid){

          var has_shuttles = false;
          var existing_shuttle = false;
          var vm = this;

          let myshuttles =  Object.assign([],this.$store.state.dynamo.shuttles);

          ////console.log(this.$store.state.dynamo.shuttles)
          ////console.log(myshuttles);

          if(myshuttles){


            has_shuttles = true;
            let currentShuttle = myshuttles.find(({id}) => id == shuttleid);
              ////console.log(res)
              if(currentShuttle){
                  existing_shuttle = true;

                  //console.log('Shuttle Exists')

                   this.$store.commit('currentShuttle', currentShuttle);

                    //

                    /*this.$nextTick()
                      .then(function () {
                        // DOM updated
                        vm.loadH5p('h5p-preview');

                      })*/



              }
          }




      }






    }






  }






</script>
    <style>
        .*, ::before ::after {
            box-sizing: border-box;
            display: block;
        }
    </style>
